<template>
    <span>
        <slot v-if="initSuccess"></slot>
    </span>
</template>

<script>
export default {
    props:{
        time:{
            required:false,
            default:0
        }
    },
    data(){
        return{
            initSuccess:false
        }
    },
    methods:{
        initSlot(){
            let _this = this
            setTimeout(()=>{
                _this.initSuccess  =true
            },(Number(_this.time || 0)))
        }
    },
    created(){
        this.initSlot()
    }
}
</script>

<style>

</style>